import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgIf} from "@angular/common";
import {SpinnerComponent} from "../spinner/spinner.component";

@Component({
    selector: 'app-button',
    imports: [
        NgIf,
        SpinnerComponent
    ],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss'
})
export class ButtonComponent {
  @Input() size: "medium" | "small" | "large" = "medium"
  @Input() disabled: boolean = false
  @Input() isLoading: boolean = false
  @Input() type: "primary" | "secondary" | "warning" = "primary"

  @Output() onClick: EventEmitter<any> = new EventEmitter()

  handleClick(event: Event) {
    event.stopPropagation()
    if (this.disabled || this.isLoading) return
    this.onClick.emit()
  }
}
